(function (root) {
  var ASKED = ['preferences', 'analytics', 'marketing'];
  var PURPOSES = ['preferences', 'analytics', 'marketing', 'sale_of_data'];
  var SHOPIFY_BANNER = 'script[src*="/shopifycloud/privacy-banner/"]';

  // Only a recorded "yes" ticks a box, so nothing stands ticked before the visitor chose.
  function ticked(consent) {
    var given = consent && typeof consent === 'object' ? consent : {};
    var boxes = {};
    for (var i = 0; i < PURPOSES.length; i += 1) boxes[PURPOSES[i]] = given[PURPOSES[i]] === 'yes';
    return boxes;
  }

  // The region decides whether to ask at all; the banner stays away once every asked purpose is answered.
  function shouldAsk(privacy) {
    try {
      if (!privacy || typeof privacy.shouldShowBanner !== 'function' || privacy.shouldShowBanner() !== true) return false;
      var given = privacy.currentVisitorConsent() || {};
      for (var i = 0; i < ASKED.length; i += 1) {
        if (given[ASKED[i]] !== 'yes' && given[ASKED[i]] !== 'no') return true;
      }
      return false;
    } catch (e) { return false; }
  }

  // Outside a sale-of-data region nobody is asked about sharing, so it follows marketing.
  function decision(kind, boxes, saleRegion) {
    var all = kind === 'accept';
    if (kind === 'accept' || kind === 'decline') return { preferences: all, analytics: all, marketing: all, sale_of_data: all };
    var chosen = boxes && typeof boxes === 'object' ? boxes : {};
    return {
      preferences: chosen.preferences === true,
      analytics: chosen.analytics === true,
      marketing: chosen.marketing === true,
      sale_of_data: saleRegion === true ? chosen.sale_of_data === true : chosen.marketing === true,
    };
  }

  // Shopify's banner arrives in content_for_header until the shop removes it; while it runs, the theme stays silent.
  function shopifyBanner(doc, win) {
    if (!doc || !doc.querySelector(SHOPIFY_BANNER)) return 'absent';
    var banner = win && win.privacyBanner;
    return banner && typeof banner.showPreferences === 'function' ? 'active' : 'pending';
  }

  var api = { ticked: ticked, shouldAsk: shouldAsk, decision: decision, shopifyBanner: shopifyBanner, SHOPIFY_BANNER: SHOPIFY_BANNER };
  root.themeConsent = api;
  if (!root.document) return;

  var document = root.document;
  var script = document.currentScript;
  var mode = script && script.dataset ? script.dataset.mode : '';
  var banner = document.querySelector('[data-consent-banner]');
  var dialog = document.querySelector('[data-consent-dialog]');
  var returnTo = null;

  // loadFeatures lives in content_for_header, which may still be arriving when this deferred file runs.
  var waiting = [];
  var privacy = null;
  function withPrivacy(callback) {
    if (privacy) { callback(privacy); return; }
    waiting.push(callback);
    if (waiting.length > 1) return;
    var tries = 0;
    (function load() {
      var shopify = root.Shopify;
      if (!shopify || typeof shopify.loadFeatures !== 'function') {
        if (++tries <= 100) root.setTimeout(load, 100);
        return;
      }
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error || !shopify.customerPrivacy) return;
        privacy = shopify.customerPrivacy;
        var queued = waiting.splice(0);
        for (var i = 0; i < queued.length; i += 1) queued[i](privacy);
      });
    })();
  }

  function showBanner() {
    if (!banner || !banner.hidden) return;
    returnTo = document.activeElement;
    banner.hidden = false;
    banner.focus({ preventScroll: true });
  }

  function hideBanner() {
    if (!banner || banner.hidden) return;
    var inside = banner.contains(document.activeElement);
    var active = document.activeElement;
    banner.hidden = true;
    if (!inside) return;
    if (returnTo && typeof returnTo.focus === 'function' && returnTo !== document.body && document.contains(returnTo)) returnTo.focus({ preventScroll: true });
    else if (active && typeof active.blur === 'function') active.blur();
  }

  function openDialog() {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    withPrivacy(function (ready) {
      var boxes = ticked(ready.currentVisitorConsent());
      var sale = false;
      try { sale = ready.saleOfDataRegion() === true; } catch (e) {}
      var inputs = dialog.querySelectorAll('input[data-consent-purpose]');
      for (var i = 0; i < inputs.length; i += 1) inputs[i].checked = boxes[inputs[i].dataset.consentPurpose] === true;
      var saleRow = dialog.querySelector('[data-consent-sale]');
      if (saleRow) saleRow.hidden = !sale;
      dialog.dataset.saleRegion = sale ? 'true' : 'false';
      if (!dialog.open) dialog.showModal();
    });
  }

  function record(kind) {
    withPrivacy(function (ready) {
      var boxes = {};
      if (kind === 'save' && dialog) {
        var inputs = dialog.querySelectorAll('input[data-consent-purpose]');
        for (var i = 0; i < inputs.length; i += 1) boxes[inputs[i].dataset.consentPurpose] = inputs[i].checked;
      }
      var values = decision(kind, boxes, dialog ? dialog.dataset.saleRegion === 'true' : false);
      ready.setTrackingConsent(values, function () {
        if (dialog && dialog.open) dialog.close();
        hideBanner();
      });
    });
  }

  function start(state) {
    if (state === 'active') return;
    if (mode !== 'theme') return;
    withPrivacy(function (ready) {
      if (shouldAsk(ready)) showBanner();
    });
  }

  // A blocked or failed Shopify script never defines the banner; after load the theme knows it is alone.
  function whenDecided(callback) {
    var state = shopifyBanner(document, root);
    if (state !== 'pending') { callback(state); return; }
    root.addEventListener('load', function () { callback(shopifyBanner(document, root) === 'active' ? 'active' : 'absent'); }, { once: true });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var opener = target.closest('[data-consent-open]');
    if (opener) {
      event.preventDefault();
      var own = shopifyBanner(document, root);
      if (own === 'active') root.privacyBanner.showPreferences();
      else openDialog();
      return;
    }
    var choice = target.closest('[data-consent-choice]');
    if (choice) {
      event.preventDefault();
      record(choice.dataset.consentChoice);
      return;
    }
    if (dialog && (target === dialog || target.closest('[data-consent-close]'))) dialog.close();
  });

  // Escape postpones the question for this page; it never counts as an answer.
  if (banner) {
    banner.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hideBanner();
    });
  }

  whenDecided(function (state) {
    var openers = document.querySelectorAll('[data-consent-open]');
    for (var i = 0; i < openers.length; i += 1) openers[i].hidden = state !== 'active' && mode !== 'theme';
    if ('requestIdleCallback' in root) root.requestIdleCallback(function () { start(state); }, { timeout: 1000 });
    else root.setTimeout(function () { start(state); }, 0);
  });
})(window);
